import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex flex-none w-full bg-gray-800 min-h-md",
  "aria-labelledby": "footerHeading"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", {
  id: "footerHeading",
  class: "sr-only"
}, " Footer ", -1)
const _hoisted_3 = { class: "container py-12 container-extra" }
const _hoisted_4 = { class: "xl:grid xl:grid-cols-3 xl:gap-8" }
const _hoisted_5 = { class: "md:grid md:grid-cols-3 md:gap-8 xl:col-span-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-semibold tracking-wider text-gray-400 uppercase" }, " Services ", -1)
const _hoisted_7 = { class: "mt-4 space-y-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Find Remote Jobs ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Post a Remote Job ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Remote Recruiting ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Sell Your Services ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://updates.dynamitejobs.com/en?utm_source=dj-platform&utm_medium=footer",
    rel: "noopener",
    class: "text-base text-gray-300 hover:text-white"
  }, " What's new? ")
], -1)
const _hoisted_13 = { class: "mt-12 md:mt-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-semibold tracking-wider text-gray-400 uppercase" }, " Company ", -1)
const _hoisted_15 = { class: "mt-4 space-y-4" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Contact Us ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" About ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://support.dynamitejobs.com/?utm_source=dj-platform&utm_medium=footer",
    class: "text-base text-gray-300 hover:text-white"
  }, " Support ")
], -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Testimonials ")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.dynamitejobs.com/remote-resources/?utm_source=dj-platform&utm_medium=footer",
    class: "text-base text-gray-300 hover:text-white"
  }, " Blog and Resources ")
], -1)
const _hoisted_21 = { class: "mt-12 md:mt-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-semibold tracking-wider text-gray-400 uppercase" }, " Legal ", -1)
const _hoisted_23 = { class: "mt-4 space-y-4" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Terms and Conditions ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Privacy Policy ")
const _hoisted_26 = { class: "mt-8 xl:mt-0" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-semibold tracking-wider text-gray-400 uppercase" }, " Subscribe to our newsletter ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-base text-gray-300" }, " Get the top 10 remote jobs, the best profiles, who's hiring, and a bit of fun once a week. ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("form", {
  id: "drip-ef-291449521",
  class: "mt-4 sm:flex sm:max-w-md",
  action: "https://www.getdrip.com/forms/291449521/submissions",
  method: "post",
  "data-drip-embedded-form": "291449521"
}, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "drip-email",
    class: "sr-only"
  }, " Email address "),
  /*#__PURE__*/_createElementVNode("input", {
    id: "drip-email",
    name: "fields[email]",
    type: "email",
    autocomplete: "email",
    class: "w-full min-w-0 px-4 py-2 text-base text-gray-900 placeholder-gray-500 bg-white border border-transparent rounded-md appearance-none focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white focus:border-white focus:placeholder-gray-400",
    placeholder: "Enter your email",
    required: ""
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "hidden",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("label", { for: "website" }, "Website"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("input", {
      id: "website",
      type: "text",
      name: "website",
      tabindex: "-1",
      autocomplete: "false",
      value: ""
    }),
    /*#__PURE__*/_createElementVNode("input", {
      id: "tags_f",
      type: "hidden",
      name: "tags[]",
      value: "Footer Form",
      tabindex: "-2"
    }),
    /*#__PURE__*/_createElementVNode("input", {
      id: "tags_n",
      type: "hidden",
      name: "tags[]",
      value: "Remotely Interesting Newsletter",
      tabindex: "-1"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-3 rounded-md sm:mt-0 sm:ml-3 sm:flex-shrink-0" }, [
    /*#__PURE__*/_createElementVNode("button", {
      "aria-label": "Subscribe",
      type: "submit",
      class: "flex items-center justify-center w-full px-4 py-2 text-base font-medium text-white transition-colors bg-red-500 border border-transparent rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-red-500"
    }, " Subscribe ")
  ])
], -1)
const _hoisted_30 = { class: "pt-8 mt-8 border-t border-gray-700" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-semibold tracking-wider text-gray-400 uppercase" }, " Browse Jobs ", -1)
const _hoisted_32 = { class: "md:grid md:grid-cols-2 xl:grid-cols-4 md:gap-x-8" }
const _hoisted_33 = { class: "mt-4 space-y-4" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Remote Virtual Assistant Jobs ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Remote Business Development & Sales Jobs ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Remote Design Jobs ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Remote Finance and Accounting Jobs ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Remote Operations Jobs ")
const _hoisted_39 = { class: "mt-12 md:mt-0" }
const _hoisted_40 = { class: "mt-4 space-y-4" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Remote Customer Service Jobs ")
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Remote Marketing Jobs ")
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Remote Product Jobs ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Remote Web Developer Jobs ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Remote Tech Support Jobs ")
const _hoisted_46 = { class: "mt-12 md:mt-0" }
const _hoisted_47 = { class: "mt-4 space-y-4" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Remote Data Analyst Jobs ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Remote Recruiter/HR Jobs ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Remote Paid Ads / PPC Jobs ")
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Remote Video Editing Jobs ")
const _hoisted_52 = { class: "mt-12 md:mt-0" }
const _hoisted_53 = { class: "mt-4 space-y-4" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Remote SEO / Content Marketing Jobs ")
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Remote Teaching Jobs ")
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Remote Writing Jobs ")
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" All Remote Jobs Categories ")
const _hoisted_58 = { class: "pt-8 mt-8 border-t border-gray-700 md:flex md:items-center md:justify-between" }
const _hoisted_59 = { class: "flex space-x-6 md:order-2" }
const _hoisted_60 = {
  href: "mailto:team@dynamitejobs.com",
  rel: "nofollow",
  class: "text-gray-400 hover:text-gray-300"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Email", -1)
const _hoisted_62 = {
  href: "tel:+1-512-256-0681",
  rel: "nofollow",
  class: "text-gray-400 hover:text-gray-300"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Phone", -1)
const _hoisted_64 = /*#__PURE__*/_createStaticVNode("<a href=\"https://www.facebook.com/dynamitejobs\" class=\"text-gray-400 hover:text-gray-300\"><span class=\"sr-only\">Facebook</span><svg class=\"w-6 h-6\" fill=\"currentColor\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path fill-rule=\"evenodd\" d=\"M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z\" clip-rule=\"evenodd\"></path></svg></a><a href=\"https://www.instagram.com/dynamite_jobs/\" class=\"text-gray-400 hover:text-gray-300\"><span class=\"sr-only\">Instagram</span><svg class=\"w-6 h-6\" fill=\"currentColor\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path fill-rule=\"evenodd\" d=\"M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z\" clip-rule=\"evenodd\"></path></svg></a><a href=\"https://twitter.com/DynamiteJobs\" class=\"text-gray-400 hover:text-gray-300\"><span class=\"sr-only\">Twitter</span><svg class=\"w-6 h-6\" fill=\"currentColor\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84\"></path></svg></a><a href=\"https://www.linkedin.com/company/dynamite-jobs\" class=\"text-gray-400 hover:text-gray-300\"><span class=\"sr-only\">LinkedIn</span><svg class=\"w-6 h-6\" fill=\"currentColor\" aria-hidden=\"true\" viewBox=\"0 0 512 512\"><path d=\"M256,0c141.29,0 256,114.71 256,256c0,141.29 -114.71,256 -256,256c-141.29,0 -256,-114.71 -256,-256c0,-141.29 114.71,-256 256,-256Zm-80.037,399.871l0,-199.921l-66.464,0l0,199.921l66.464,0Zm239.62,0l0,-114.646c0,-61.409 -32.787,-89.976 -76.509,-89.976c-35.255,0 -51.047,19.389 -59.889,33.007l0,-28.306l-66.447,0c0.881,18.757 0,199.921 0,199.921l66.446,0l0,-111.65c0,-5.976 0.43,-11.95 2.191,-16.221c4.795,-11.935 15.737,-24.299 34.095,-24.299c24.034,0 33.663,18.34 33.663,45.204l0,106.966l66.45,0Zm-272.403,-296.321c-22.74,0 -37.597,14.95 -37.597,34.545c0,19.182 14.405,34.544 36.717,34.544l0.429,0c23.175,0 37.6,-15.362 37.6,-34.544c-0.43,-19.595 -14.424,-34.545 -37.149,-34.545Z\"></path></svg></a>", 4)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("p", { class: "mt-8 text-base text-gray-400 md:mt-0 md:order-1" }, [
  /*#__PURE__*/_createTextVNode(" © 2021 Dynamite Ventures, Inc. All rights reserved. Call Us: "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-gray-400 hover:text-gray-300",
    href: "tel:+1-512-256-0681",
    rel: "nofollow"
  }, " (512) 256-0681 "),
  /*#__PURE__*/_createTextVNode(" Email: "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-gray-400 hover:text-gray-300",
    href: "mailto:team@dynamitejobs.com",
    rel: "nofollow"
  }, " team@dynamitejobs.com ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_DJLogoShort = _resolveComponent("DJLogoShort")!
  const _component_MailIcon = _resolveComponent("MailIcon")!
  const _component_PhoneIcon = _resolveComponent("PhoneIcon")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _hoisted_6,
            _createElementVNode("ul", _hoisted_7, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: !_ctx.loggedIn ? 'how-to-find-remote-jobs' : 'candidate-pro', params: { utm_source: 'dj-platform', utm_medium: 'footer' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'post-a-remote-job', params: { utm_source: 'dj-platform', utm_medium: 'footer' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'remote-recruiting', params: { utm_source: 'dj-platform', utm_medium: 'footer' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'list-your-services', params: { utm_source: 'dj-platform', utm_medium: 'footer' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                })
              ]),
              _hoisted_12
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("ul", _hoisted_15, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'contact-us', params: { utm_source: 'dj-platform', utm_medium: 'footer' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'about', params: { utm_source: 'dj-platform', utm_medium: 'footer' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                })
              ]),
              _hoisted_18,
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'success-stories', params: { utm_source: 'dj-platform', utm_medium: 'footer' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                })
              ]),
              _hoisted_20
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("ul", _hoisted_23, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'terms' },
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'privacy' },
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createVNode(_component_DJLogoShort, { class: "h-8 my-5 text-red-600" }),
          _hoisted_28,
          _hoisted_29
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_RouterLink, {
          to: { name: 'jobs', params: { utm_source: 'dj-platform', utm_medium: 'footer' }},
          class: "text-base text-gray-300 hover:text-white"
        }, {
          default: _withCtx(() => [
            _hoisted_31
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", null, [
            _createElementVNode("ul", _hoisted_33, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'admin-va' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_34
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'business-development' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'design' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_36
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'finance-accounting' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_37
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'management-operations' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_38
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("ul", _hoisted_40, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'customer-support' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_41
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'marketing' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_42
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'product' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_43
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'development' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_44
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'technical-support' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_45
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("ul", _hoisted_47, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'data-analyst' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_48
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'hr-recruiter' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_49
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'paid-ads' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_50
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'multimedia' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_51
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("ul", _hoisted_53, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'seo' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_54
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'teacher-coach' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_55
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'jobs-category', params: {category: 'writing-editing' }},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_56
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: {name: 'remote-jobs-categories-view'},
                  class: "text-base text-gray-300 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_57
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("a", _hoisted_60, [
            _hoisted_61,
            _createVNode(_component_MailIcon, {
              "aria-hidden": "true",
              class: "w-6 h-6"
            })
          ]),
          _createElementVNode("a", _hoisted_62, [
            _hoisted_63,
            _createVNode(_component_PhoneIcon, {
              "aria-hidden": "true",
              class: "w-6 h-6"
            })
          ]),
          _hoisted_64
        ]),
        _hoisted_68
      ])
    ])
  ]))
}